import { render, staticRenderFns } from "./SchedulesSection.vue?vue&type=template&id=15fbe604&"
import script from "./SchedulesSection.vue?vue&type=script&lang=js&"
export * from "./SchedulesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fbe604')) {
      api.createRecord('15fbe604', component.options)
    } else {
      api.reload('15fbe604', component.options)
    }
    module.hot.accept("./SchedulesSection.vue?vue&type=template&id=15fbe604&", function () {
      api.rerender('15fbe604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/SchedulesSection.vue"
export default component.exports